import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ProductGridWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-left: -10px;
  margin-right: -10px;
`;

export const EntitiesListingWrapper = styled.div`
  width: 100%;
`;

export const HeaderWithButtons = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${media.md`
    justify-content: flex-start;
  `};
`;

export const ButtonContainer = styled.span`
  display: inline-flex;

  ${media.md`
    margin-left: 100px;
  `};
`;

export const ChevronButton = styled.button`
  display: inline-flex;
  border: 0;
  padding: 0;
  border-radius: 100%;
  background: #ffffff;
  color: #c1c1c1;
  cursor: pointer;
  margin: 5px;

  &:disabled {
    opacity: 0.5;
    cursor: default;
    background: transparent;
  }
`;

export const StyledPageDescription = styled.div`
  display: none;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  line-height: 23px;

  ${media.md`
    display: block;
  `};

  ${media.xl`
    max-width: 66%;
  `};
`;

export const JourneyPickerOuterWrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
`;

export const JourneyPickerInnerWrapper = styled.div`
  width: 100%;
  max-width: 1480px;
  padding: 0 12px;

  @media screen and (min-width: 601px) {
    padding: 0 20px;
  }
`;
